<template>
  <el-dialog
    v-dialogDrag
    title="绑定测点"
    :visible.sync="bindingDialogShow"
    :before-close="beforeClose"
    width="1200px"
    top="5vh"
  >
    <el-row :gutter="20" class="h-610px">
      <!-- 穿梭框左侧 -->
      <el-col :span="10" class="h-full">
        <el-card class="h-full">
          <div class="h-40px bg-blue-300/20 leading-40px text-16px pl-10px">服务端</div>
          <div class="h-9/10">
            <div>
              <el-input
                placeholder="请输入搜索内容"
                clearable
                v-model="filterText"
                class="rounded-3xl mt-5px w-250px"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  @click="searchTree"
                ></el-button>
              </el-input>
              <el-tooltip content="导出">
                <el-button
                  v-loading="exportServiceLoading"
                  type="primary"
                  size="mini"
                  class="iconfont icon-bg-export pull-right mt-10px"
                  @click="exportServiceTags"
                  :disabled="!$hasAccess('export')"
                ></el-button>
              </el-tooltip>
            </div>

            <!-- 左侧采用虚拟滚动树组件 -->
            <virtual-scroll-tree
              v-if="treeShow"
              class="h-9/10 overflow-auto"
              ref="treeLeft"
              :data="dataLeft"
              :load="loadNode"
              :lazy="true"
              check-strictly
              show-checkbox
              @node-click="handleNodeClick"
              :node-key="defaultProps.id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @check="leftCheck"
              :expand-on-click-node="false"
            >
            </virtual-scroll-tree>
          </div>
        </el-card>
      </el-col>
      <!-- 穿梭框中间按钮区域 -->
      <el-col :span="4" class="flex justify-center items-center h-full">
        <el-button
          type="primary"
          class="iconfont icon-line-left flex justify-center items-center text-12px w-20px"
          @click="removePoint"
          size="mini"
        ></el-button>
        <el-button
          type="primary"
          class="iconfont icon-line-right flex justify-center items-center text-12px w-20px"
          @click="addPoint"
          size="mini"
        ></el-button>
      </el-col>
      <!-- 穿梭框右侧 -->
      <el-col :span="10" class="h-full">
        <el-card class="h-full">
          <div class="h-40px bg-blue-300/20 leading-40px text-16px pl-10px">客户端</div>
          <!-- 右侧直接放置结果 -->
          <div class="h-9/10 overflow-auto">
            <div>
              <el-input
                placeholder="请输入搜索内容"
                clearable
                v-model="filterTextRight"
                class="rounded-3xl mt-5px w-250px"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  @click="searchRight"
                ></el-button>
              </el-input>
              <!-- <el-tooltip content="导出">
                <el-button
                  size="mini"
                  type="primary"
                  class="pull-right mt-10px iconfont icon-bg-export"
                  @click="exportClientTags"
                  :disabled="!$hasAccess('export')"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="导入">
                <el-button
                  @click="importClientTags"
                  class="pull-right mt-10px mr-10px iconfont icon-bg-import"
                  type="primary"
                  size="mini"
                  :disabled="!$hasAccess('import')"
                ></el-button>
              </el-tooltip> -->
            </div>
            <el-checkbox-group v-model="rightChecked">
              <virtual-list
                v-if="filteredDataRight.length > 0"
                class="virtual-list"
                height="500px"
                data-key="id"
                :data-sources="filteredDataRight"
                :data-component="itemComponent"
                :extra-props="{ editPoint: this.editPoint }"
                :item-height="40"
                ref="virtualList"
              />
              <div v-else class="text-center py-10px">暂无数据</div>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer flex justify-center">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </span>
    <com-dialog
      v-if="addDialogShow"
      :addDialogShow="addDialogShow"
      :dataSourceDirectName="sourceType"
      :folderId="folderId"
      :standardId="standardId"
      :dataSourceConfigId="bindingSourceDetail.dataSourceConfigId"
      :dialogTitle="dialogTitle"
      :measuringPointDetail="measuringPointDetail"
      :handlerType="handlerType"
      @binding="handleBinding"
      :appendToBody="true"
      @addDialogClose="addDialogClose"
      @editedData="editedData"
    />
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getMearsuringList()"
      v-if="showUploadExcelDialog"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-dialog>
</template>
<script>
import { isEmpty, forEach, map } from 'lodash'
import MeasuringPointService from '@/services/MeasuringPointService'
import ComDialog from './comDialog'
import fnMixins from '@/assets/js/fnMixins'
import VirtualScrollTree from '@/components/virtualScrollTree/tree.vue'
import VirtualList from 'vue-virtual-scroll-list'
import { wizUploadFile } from '@wiz-core/compts'
export default {
  name: 'binding-dialog',
  components: {
    wizUploadFile,
    ComDialog,
    VirtualScrollTree,
    VirtualList,
  },
  mixins: [fnMixins],
  props: {
    bindingDialogShow: {
      type: Boolean,
      default: false,
    },
    bindingSourceDetail: {
      type: String,
      default: () => {
        return {}
      },
    },
    standardId: {
      type: String,
      default: '',
    },
    folderId: {
      type: String,
      default: '',
    },
  },
  watch: {
    dataRight: {
      handler(newVal, oldVal) {
        console.log('dataRight changed:', newVal)
        // 当dataRight变化时，更新过滤后的结果
        this.filteredDataRight = this.dataRight
      },
      deep: true,
    },
  },
  data() {
    return {
      showUploadExcelDialog: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      exportServiceLoading: false,
      filterText: '',
      filterTextRight: '',
      sourceType: null,
      addDialogShow: false,
      treeShow: false,
      itemStart: false, // 是否从itemPrefix开始
      handlerType: 'binding',
      measuringPointDetail: [],
      dataLeft: [],
      findList: [],
      pointList: [],
      defaultProps: {
        id: 'id',
        label: 'name',
        children: 'children',
      },
      rightChecked: [],
      dataRight: [],
      filteredDataRight: [],
      rootPageNo: 1,
      // 总条数跟踪
      totalCounts: {},
      // 已加载的节点数
      loadedCounts: {},
      // 虚拟滚动列表项组件
      itemComponent: {
        props: {
          source: {
            type: Object,
            default: () => ({}),
          },
          editPoint: {
            type: Function,
            default: () => {},
          },
        },
        render(h) {
          return h(
            'el-checkbox',
            {
              props: {
                label: this.source,
              },
              class: 'block',
            },
            [
              h(
                'div',
                {
                  class: 'flex justify-between w-full',
                },
                [
                  h(
                    'el-tooltip',
                    {
                      props: {
                        effect: 'light',
                        content: this.source.id,
                        placement: 'bottom-start',
                      },
                    },
                    [
                      h(
                        'span',
                        {
                          class: 'w-full overflow-ellipsis whitespace-nowrap overflow-hidden',
                        },
                        this.source.name
                      ),
                    ]
                  ),
                  h(
                    'button',
                    {
                      attrs: {
                        size: 'mini',
                      },
                      on: {
                        click: (event) => {
                          debugger
                          event.stopPropagation()
                          // 直接调用props传递的editPoint方法
                          this.editPoint(this.source)
                        },
                      },
                    },
                    '编辑'
                  ),
                ]
              ),
            ]
          )
        },
      },
    }
  },
  async created() {
    this.dialogTitle = '编辑测点'
    this.sourceType = this.bindingSourceDetail.dataSourceDirectName.toLowerCase()
    this.initLeftTree()
    this.treeShow = true
    // 初始化过滤后的结果
    this.filteredDataRight = this.dataRight
  },
  methods: {
    async exportTemplate() {
      const res = await MeasuringPointService.downloadExportTemplate({
        protocolType: this.bindingSourceDetail.protocolType,
      })
      if (res) {
        this.downLoadExcel('测点管理导入模板.xlsx', res)
      }
    },
    async importTemplate(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('dataSourceConfigId', this.bindingSourceDetail.dataSourceConfigId)
      formData.append('protocolType', this.bindingSourceDetail.protocolType)
      const res = await MeasuringPointService.import(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.uploadFileProps.successCount = res.data.successCount
        this.uploadFileProps.failureCount = res.data.failureCount
        // 如需兼容老样式，则resultFile字段为空或者不设置皆可
        this.uploadFileProps.resultFile = res.data.resultFile
      }
      this.uploadFileProps.btnLoading = false
    },
    // 下载导入结果
    async exportResults() {
      const [err, res] = await MeasuringPointService.downImportInfoUsingGET({
        id: this.uploadFileProps.resultFile,
      })
      if (!err) {
        this.downLoadBlob({
          name: '测点导入结果.xlsx',
          data: res,
        })
      }
    },
    importClientTags() {
      // 导入客户端测点
      this.showUploadExcelDialog = true
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    exportClientTags() {
      // 导出客户端测点
    },
    async exportServiceTags() {
      // 导出服务端测点
      this.exportServiceLoading = true
      const res = await MeasuringPointService.exportServiceTags({
        ProtocolType: this.bindingSourceDetail.protocolType,
        Ids: map(this.pointList, 'id'),
      })
      this.exportServiceLoading = false
      if (res) {
        this.downLoadExcel('服务端导出测点.xlsx', res)
      }
    },
    searchTree() {
      this.$refs.treeLeft.filter(this.filterText)
    },
    searchRight() {
      // 搜索方法
      this.filterRightData()
    },
    filterRightData() {
      // 过滤右侧数据
      if (!this.filterTextRight) {
        this.filteredDataRight = this.dataRight
      } else {
        this.filteredDataRight = this.dataRight.filter((item) => {
          return item.name && item.name.indexOf(this.filterTextRight) !== -1
        })
      }
      // 手动刷新虚拟滚动组件
      this.$nextTick(() => {
        if (this.$refs.virtualList) {
          this.$refs.virtualList.reset()
        }
      })
    },
    async loadNode(node, resolve) {
      console.log('node', node)
      if (node.level > 0) {
        const nodeId = node.data.id

        // 检查是否有保存的已加载数量，如果没有则为0
        const currentLoadedCount = this.loadedCounts[nodeId] || 0

        // 确定要加载的数量
        // 如果是第一次加载，只加载5条；如果已经加载过，加载所有已加载的数据加上新的100条
        const maxResultCount = currentLoadedCount === 0 ? 5 : currentLoadedCount + 5

        console.log('加载节点', nodeId, '已加载:', currentLoadedCount, '计划加载:', maxResultCount)
        if (nodeId === 'load-more') {
          return
        }
        // 正常加载子节点
        const res = await MeasuringPointService.getServerPointPaged({
          ParentId: nodeId,
          Ip: this.bindingSourceDetail.localIp,
          ProtocolType: this.bindingSourceDetail.protocolType,
          SkipCount: 0, // 总是从0开始加载，因为我们需要获取连续的数据
          MaxResultCount: 100,
        })

        console.log('正常加载子节点，节点ID:', nodeId, '返回数据:', res)

        if (res && res.code === 0) {
          // 保存总条数
          this.totalCounts[nodeId] = res.totalCount || 0

          // 更新已加载条数为当前获取的所有数据数量
          this.loadedCounts[nodeId] = res.data ? res.data.length : 0

          console.log(
            '节点',
            nodeId,
            '总条数:',
            this.totalCounts[nodeId],
            '已加载:',
            this.loadedCounts[nodeId]
          )

          // 处理返回的数据
          const resData = _.map(res.data || [], (item) => {
            item.children = []
            return item
          })

          // 如果当前层级的数据小于总条数，添加加载更多节点
          if (this.loadedCounts[nodeId] < this.totalCounts[nodeId]) {
            resData.push({
              id: 'load-more',
              name: '•••',
              isLoadMore: true,
              parentId: nodeId,
            })
            console.log('添加加载更多节点到', nodeId)
          }

          resolve(resData)
        } else {
          console.error('正常加载子节点失败:', res)
          resolve([])
        }
      } else {
        // 根节点不需要加载
        resolve([])
      }
    },
    leftCheck(current, all) {
      console.log('leftCheck - all.checkedNodes:', all.checkedNodes)
      this.pointList = all.checkedNodes
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    beforeClose() {
      this.closeDialog()
    },
    cancel() {
      this.closeDialog()
    },
    addPoint() {
      if (isEmpty(this.pointList)) {
        this.$message.warning('请选择要添加的测点')
        return
      }
      console.log('addPoint - pointList:', this.pointList)
      const newDataRight = this.pointList.map((item) => ({
        ...item,
        // name: item.object.full,
        code: item.object.kks,
        serverMeasuringPointId: item.id,
        serverMeasuringPointFull: item.object.full,
      }))
      console.log('addPoint - newDataRight:', newDataRight)
      this.dataRight = newDataRight
      console.log('addPoint - dataRight after assignment:', this.dataRight)
      // 手动刷新虚拟滚动组件
      this.$nextTick(() => {
        if (this.$refs.virtualList) {
          this.$refs.virtualList.reset()
          console.log('Virtual list refreshed')
        }
      })
    },
    removePoint() {
      if (isEmpty(this.rightChecked)) {
        this.$message.warning('请选择要移除的测点')
        return
      }
      this.dataRight = this.dataRight.filter(
        (item) => this.rightChecked.findIndex((it) => it.id === item.id) === -1
      )
      this.rightChecked = []
    },
    // 绑定测点，编辑后的数据
    editedData(data) {
      forEach(this.dataRight, (item, index) => {
        if (item.initial === data.initial) {
          this.dataRight[index] = data
        }
      })
    },
    editPoint(data) {
      this.measuringPointDetail = {
        kks: data.code,
        pointName: data.name,
        id: data.id,
        ...data,
      }
      this.addDialogShow = true
    },
    closeDialog() {
      this.dataLeft = this.$options.data().dataLeft
      this.dataRight = this.$options.data().dataRight
      this.$emit('bindingDialogClose')
    },
    addDialogClose() {
      this.addDialogShow = false
      this.measuringPointDetail = this.$options.data().measuringPointDetail
    },
    async save() {
      if (isEmpty(this.dataRight)) {
        this.$message.warning('请选择测点后保存')
        return
      }
      const res = await Promise.all(
        this.dataRight.map((item) => {
          return MeasuringPointService.addPoint({
            ...item,
            dataSourceConfigId: this.bindingSourceDetail.dataSourceConfigId,
            standardId: this.standardId,
            folderId: this.folderId,
          })
        })
      )
      if (res.every((item) => item.code === 0)) {
        this.$message.success('保存成功')
        this.$emit('refreshList')
        this.closeDialog()
      }
    },
    // 处理节点点击事件，用于加载更多节点
    async handleNodeClick(data, node) {
      // 检查是否是加载更多节点
      if (data.isLoadMore) {
        // 获取父节点
        const parentNode = node.parent
        if (!parentNode) return

        const parentId = node.data.parentId

        // 计算当前页码
        const pageNo = Math.floor(this.loadedCounts[parentId] / 100) + 1

        // 调用API加载更多数据
        const res = await MeasuringPointService.getServerPointPaged({
          ParentId: parentId,
          Ip: this.bindingSourceDetail.localIp,
          ProtocolType: this.bindingSourceDetail.protocolType,
          SkipCount: this.loadedCounts[parentId], // 从已加载的数量开始加载
          MaxResultCount: 100,
        })

        if (res && res.code === 0) {
          // 更新已加载条数
          this.loadedCounts[parentId] += res.data ? res.data.length : 0

          // 处理返回的新数据
          const newData = res.data || []

          // 获取所有当前子节点（不包括加载更多节点）
          const currentChildren = parentNode.childNodes
            .filter((child) => !child.data.isLoadMore)
            .map((child) => child.data)

          // 合并当前子节点和新加载的子节点
          const mergedChildren = [...currentChildren, ...newData]

          // 如果还有更多数据，添加新的加载更多节点
          if (this.loadedCounts[parentId] < this.totalCounts[parentId]) {
            mergedChildren.push({
              id: 'load-more',
              name: '•••',
              isLoadMore: true,
              parentId: parentId,
            })
          }

          // 使用doCreateChildren方法重新创建所有子节点，这是TreeStore期望的方式
          parentNode.childNodes = []
          parentNode.doCreateChildren(mergedChildren)

          // 更新父节点的loaded状态
          parentNode.loaded = true
          parentNode.updateLeafState()
        }
      }
    },
    async initLeftTree() {
      const res = await MeasuringPointService.getServerPointPaged({
        ParentId: '00000000-0000-0000-0000-000000000000',
        Ip: this.bindingSourceDetail.localIp,
        ProtocolType: this.bindingSourceDetail.protocolType,
        SkipCount: (this.rootPageNo - 1) * 100,
        MaxResultCount: 100,
      })
      if (res && res.code === 0) {
        const rootId = '00000000-0000-0000-0000-000000000000'
        // 保存总条数和已加载条数
        this.totalCounts[rootId] = res.totalCount || 0
        this.loadedCounts[rootId] = (this.rootPageNo - 1) * 100 + (res.data ? res.data.length : 0)

        // 如果是第一页，初始化数据，否则追加数据
        if (this.rootPageNo === 1) {
          this.dataLeft = res.data || []
        } else {
          // 移除之前的加载更多节点
          this.dataLeft = this.dataLeft.filter((item) => item.id !== 'load-more')
          // 追加新数据
          this.dataLeft = [...this.dataLeft, ...(res.data || [])]
        }

        // 如果当前层级的数据小于总条数，添加加载更多节点
        if (this.loadedCounts[rootId] < this.totalCounts[rootId]) {
          this.dataLeft.push({
            id: 'load-more',
            name: '•••',
            isLoadMore: true,
            parentId: rootId,
          })
        }
      }
    },
    handleBinding(data) {
      console.log(data)
      this.dataRight = this.dataRight.map((item) => {
        if (item.id === data.id) {
          return {
            ...data,
            name: data.pointName,
            code: data.kks,
            serverMeasuringPointId: item.id,
            serverMeasuringPointFull: item.object.full,
          }
        }
        return item
      })
    },
  },
}
</script>

<style scoped lang="scss">

::v-deep .el-button--mini {
  .el-loading-spinner {
    margin-top: -16px !important;
  }
  svg {
    width: 25px !important;
    height: 25px !important;
  }
}
.h-610px {
  height: 610px !important;
}
::v-deep .el-checkbox__label {
  width: 90%;
}
::v-deep .el-checkbox {
  margin-right: 0 !important;
}
.virtual-list {
  width: 100%;
}
::v-deep .virtual-list .el-checkbox {
  width: 100%;
  margin-bottom: 8px;
}

</style>
